import React, { useState } from 'react';

import { Popup } from '@atlaskit/popup';
import { Pressable, xcss } from '@atlaskit/primitives';

import { ReadTimeComponent } from './ReadTimeComponent';
import { ReadTimePopup } from './ReadTimePopup';
import type { ContentFeatures } from './featuresExtractor';

const triggerStyles = xcss({
	display: 'inline-flex',
	color: 'color.text',
	padding: 'space.0',
	borderRadius: 'border.radius.100',
	backgroundColor: 'color.background.neutral.subtle',
});

export const ReadTimePopupExperiment = ({
	contentId,
	isAbbreviatedReadTime,
	isDetailsPanel,
	showWordCount,
	features,
	featuresSkipExpand,
	wordCount,
	readTime,
}: {
	contentId: string;
	isAbbreviatedReadTime?: boolean;
	isDetailsPanel?: boolean;
	showWordCount?: boolean;
	features: ContentFeatures | null;
	featuresSkipExpand: ContentFeatures | null;
	wordCount: number;
	readTime: number | null;
}) => {
	const [isPopupOpen, setIsPopupOpen] = useState(false);

	return (
		<Popup
			isOpen={isPopupOpen}
			onClose={() => setIsPopupOpen(false)}
			placement="bottom-start"
			content={(props) => (
				<ReadTimePopup {...props} features={features} featuresSkipExpand={featuresSkipExpand} />
			)}
			trigger={(triggerProps) => (
				<Pressable
					{...triggerProps}
					onClick={() => setIsPopupOpen(!isPopupOpen)}
					xcss={triggerStyles}
				>
					<ReadTimeComponent
						readTime={readTime}
						wordCount={wordCount}
						pageId={contentId}
						isAbbreviatedReadTime={isAbbreviatedReadTime}
						isDetailsPanel={isDetailsPanel}
						showWordCount={showWordCount}
					/>
				</Pressable>
			)}
		/>
	);
};
